export default {
  init() {

    let plyr = window.Plyr;
    // JavaScript to be fired on the home page
    let showreelPlayer = new plyr(document.getElementById('player'), {
      clickToPlay: false,
      autopause: false,
      autoplay: true,
      muted: true,
      debug: true,
      hideControls: false,
      controls: ['stop', 'play', 'progress', 'current-time', 'mute', 'volume'],
    });

    showreelPlayer.on('ready', () => {
      showreelPlayer.muted = true
      showreelPlayer.play();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/showreel.js